export default [
  { label: 'Office', value: 'Office' },
  { label: 'Mobile', value: 'Mobile' },
  { label: 'Fax', value: 'Fax' },
  { label: 'Other', value: 'Other' },
];
